module.exports = __webpack_public_path__ + "static/img/SmartPlatform4.8ab1791.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/SmartPlatform4.png
// module id = 61WW
// module chunks = 13